import { z } from 'zod';
export var CreateConstructionSchema = z.object({
    name: z.string().min(1, 'Поле обязательно для заполнения'),
    constructionType: z.string().min(1, 'Поле обязательно для заполнения'),
    construction: z.string().min(1, 'Поле обязательно для заполнения'),
    firstPlacementRoom: z.string().min(1, 'Поле обязательно для заполнения'),
    secondPlacementRoom: z.string().min(1, 'Поле обязательно для заполнения'),
    area: z
        .string()
        .min(1, 'Поле обязательно для заполнения')
        .refine(function (value) { return Number.isInteger(Number(value)); }, 'Значение должно быть целым числом')
        .refine(function (value) { return +value > 0; }, 'Значение должно быть больше нуля'),
    width: z
        .string()
        .min(1, 'Поле обязательно для заполнения')
        .refine(function (value) { return Number.isInteger(Number(value)); }, 'Значение должно быть целым числом')
        .refine(function (value) { return +value > 0; }, 'Значение должно быть больше нуля'),
    length: z
        .string()
        .min(1, 'Поле обязательно для заполнения')
        .refine(function (value) { return Number.isInteger(Number(value)); }, 'Значение должно быть целым числом')
        .refine(function (value) { return +value > 0; }, 'Значение должно быть больше нуля'),
});
